import React, { useState, useMemo } from 'react';
import TemplateCompleteSection from '../Templates/TemplateCompleteSection';
import TemplateTwoSection from '../Templates/TemplateTwoSection';
import TemplateFourSection from '../Templates/TemplateFourSection';
import TemplateTwoSectionAndRightVertical from '../Templates/TemplateTwoSectionAndRightVertical';
import TemplateTwoSectionAndRightFour from '../Templates/TemplateTwoSectionAndRightFour';
import TemplateTwoSectionAndLeftVertical from '../Templates/TemplateTwoSectionAndLeftVertical';
import TemplateTwoSectionAndLeftFour from '../Templates/TemplateTwoSectionAndLeftFour';
import { completeSection, fourSection, twoSection, twoSectionAndLeftFour, twoSectionAndLeftVertical, twoSectionAndRightFour, twoSectionAndRightVertical } from '../utils/templatesAPI';
import { useDispatch, useSelector } from 'react-redux';
import { AddNurseryStoreTemplatesAsync, changeTemplateRenderPositionAsync, deleteNurseryStoreTemplatesAsync, deleteTabSectionAsync, deleteTemplateFromSectionAsync, nurseryStoreImagesUpload, nurseryStoreTabDeleteAsync, nurseryStoreTabEditAsync, nurseryStoreTemplatesChangeRenderPositionByTabsIdAsync } from '../../nurserySlice';
import ChooseTemplate from '../../../common/ChooseTemplate';
import { message, Tooltip } from 'antd';
import AddBlocksModel from '../Blocks/AddBlocksModel';
import EditBlocksModel from '../Blocks/EditBlocksModel';
import { Link } from 'react-router-dom';

const TabsViewEditing = ({ content, nurseryStoreTabsSelected }) => {

    const { status, tabName } = nurseryStoreTabsSelected;
    const nurseryId = useSelector(state => state.nursery.nursery._id);


    const nurseryStoreBlocks = useSelector(state => state.nursery.nurseryStoreBlocks);
    const isCurrentTab = useSelector(state => state.nursery.isCurrentTab);

    const dispatch = useDispatch();

    const [isViewMode, setIsViewMode] = useState(false);
    const [isChooseModeOpen, setIsChooseModeOpen] = useState(false);
    const [atIndex, setAtIndex] = useState(null);
    const [atBlockIndex, setAtBlockIndex] = useState(null);
    const [isCurrentTemplates, setIsCurrentTemplates] = useState(null);
    const [isCurrentBlock, setIsCurrentBlock] = useState(null);

    const [isModelOpen, setIsModelOpen] = useState(false);
    const [isModelOpenEdit, setIsModelOpenEdit] = useState(false);

    //^ Ant Design Tooltip 
    const [arrow, setArrow] = useState('Show');
    const mergedArrow = useMemo(() => {
        if (arrow === 'Hide') {
            return false;
        }
        if (arrow === 'Show') {
            return true;
        }
        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const handelSelectedTemplate = async (templateName) => {
        setIsChooseModeOpen(false);

        if (isCurrentTab && isCurrentTab !== "info") {

            const initTemplateData = {
                nurseryStoreTabs: isCurrentTab.toString().toLocaleLowerCase(),
                index: atIndex ?? 0,
                templateName
            }

            dispatch(AddNurseryStoreTemplatesAsync(initTemplateData));

        } else message.error("Error: Current Tabs not found.");
    }

    const handleImageUploadNurseryStore = async (e, renderId, imageId) => {
        e.preventDefault();

        // const contentIndex = nurseryStore.findIndex(content => content.tabName.toLocaleLowerCase() === isCurrentTab.toLocaleLowerCase());

        // const tabId = nurseryStore[contentIndex]._id;

        // const data = new FormData();
        // data.append(e.target.name, e.target.files[0]);
        // data.append("nurserId", nursery._id);
        // data.append("user", nursery.user);
        // data.append("rendersId", renderId);
        // data.append("tabId", tabId);


        // dispatch(nurseryStoreImagesUpload({ imageId, data }))
    }


    const handelDeleteRendersUpload = async (index) => {
        // const contentIndex = nurseryStore.findIndex(content => content.tabName.toLocaleLowerCase() === isCurrentTab.toLocaleLowerCase());

        // const newContents = { ...nurseryStore[contentIndex] };

        // const newRenders = [...newContents.renders];


        // newRenders.splice(index, 1);

        // newContents.renders = newRenders;

        // const data = newContents;

        // data.user = nursery.user;
        // data.nursery = nursery._id;

        // dispatch(deleteTemplateFromSectionAsync({ _id: data._id, data }))
    }

    const handelChangeRenderPosition = async (prev, next) => {

        //! if we move two or more steps up and down, to change the positions 
        if (!prev || !next || Math.abs(prev.index - next.index) != 1) {
            message.error("Invalid Change Render Position");
            return;
        }

        const data = {
            preData: {
                _id: prev._id,
                index: prev.index
            },
            nextData: {
                _id: next._id,
                index: next.index
            }
        }


        //! if current section is not info or null or undefined
        if (!isCurrentTab || isCurrentTab !== 'info') {
            dispatch(nurseryStoreTemplatesChangeRenderPositionByTabsIdAsync({ id: isCurrentTab, data }));
        } else {
            alert("Error: Current Tabs not found.")
        }
    }


    const renderContents = content && content.map((elem, index) => {
        const blocksData = nurseryStoreBlocks && nurseryStoreBlocks.filter(blockData => (blockData.nurseryStoreTabs.toLocaleLowerCase() === isCurrentTab.toLocaleLowerCase()) && blockData.nurseryStoreTemplates.toLocaleLowerCase() === elem._id.toLocaleLowerCase());

        const blocks = []; //? creating empty blocks of arrays....

        //* Sort blocks based on their index
        blocksData.forEach(e => {
            blocks[e.index] = e;
        });

        return (
            <div key={elem._id} className="mb-4 nursery-store-card p-3 p-md-4 position-relative template-images">
                <div className='row flex-column-reverse flex-md-row'>
                    {elem.templateName === "completeSection" && <TemplateCompleteSection content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    {elem.templateName === "twoSection" && <TemplateTwoSection content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    {elem.templateName === "fourSection" && <TemplateFourSection content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    {elem.templateName === "twoSectionAndRightVertical" && <TemplateTwoSectionAndRightVertical content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    {elem.templateName === "twoSectionAndRightFour" && <TemplateTwoSectionAndRightFour content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    {elem.templateName === "twoSectionAndLeftVertical" && <TemplateTwoSectionAndLeftVertical content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    {elem.templateName === "twoSectionAndLeftFour" && <TemplateTwoSectionAndLeftFour content={blocks} index={elem.index} handelDeleteRendersUpload={handelDeleteRendersUpload} handleImageUploadNurseryStore={handleImageUploadNurseryStore} mergedArrow={mergedArrow} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={elem._id} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} />}
                    <div className="position-absolute top-0 end-0 p-2 builder-actions-overlay m-3 shadow-sm d-flex justify-content-center align-items-center" style={{ width: 'max-content', zIndex: 10 }}>
                        <Tooltip placement="left" title={'Delete Template'} arrow={mergedArrow} onClick={() => dispatch(deleteNurseryStoreTemplatesAsync(elem._id))}>
                            <button className="btn btn-sm btn-outline-danger border-0 rounded-circle"><i className="fas fa-trash cursor-pointer"></i></button>
                        </Tooltip>
                    </div>

                </div>

                {
                    content.length - 1 === index ?

                        <div className='d-flex justify-content-between align-items-center' >
                            <div className="border w-100"></div>
                            <div className="rounded p-2 cursor-pointer" style={{ fontSize: "20px" }} onClick={() => { setAtIndex(1 + Number.parseInt(elem.index)); setIsChooseModeOpen(true) }}><i className="fas fa-plus-circle"></i></div>
                            <div className="border w-100"></div>
                        </div>
                        :

                        //* ⬆️ ➕ ⬇️ Render after every render elements........
                        <div className='d-flex justify-content-between align-items-center' >
                            <div className="border w-100"></div>
                            <div className="rounded p-2 cursor-pointer" style={{ fontSize: "20px" }} onClick={() => handelChangeRenderPosition({ _id: content[index + 1]._id, index: index + 1 }, { _id: content[index]._id, index })}><i className="far fa-arrow-alt-circle-up"></i></div>
                            <div className="rounded p-2 cursor-pointer" style={{ fontSize: "20px" }} onClick={() => { setAtIndex(1 + Number.parseInt(elem.index)); setIsChooseModeOpen(true) }}><i className="fas fa-plus-circle"></i></div>
                            <div className="rounded p-2 cursor-pointer" style={{ fontSize: "20px" }} onClick={() => handelChangeRenderPosition({ _id: content[index]._id, index }, { _id: content[index + 1]._id, index: index + 1 })}><i className="far fa-arrow-alt-circle-down"></i></div>
                            <div className="border w-100"></div>
                        </div>
                }
            </div>
        )
    })

    return (
        <>
            <div key={isCurrentTab} className={`p-0 p-md-3 ${isViewMode ? 'builder-view-mode' : ''}`}>
                <div className="d-flex justify-content-center mb-4 mt-2">
                    <div className="workflow-action-bar">
                        <div className={`workflow-status-badge ${status.toLowerCase()}`}>
                            <div className="workflow-status-dot"></div>
                            {status}
                        </div>
                        
                        <div style={{ width: '1px', height: '24px', backgroundColor: '#eaeaea', margin: '0 4px' }}></div>

                        <button className={`btn btn-sm ${isViewMode ? 'btn-info' : 'btn-outline-info'} workflow-btn`} onClick={() => setIsViewMode(!isViewMode)}>
                            <span style={{ fontSize: "16px" }} className="material-symbols-outlined me-1">visibility</span> {isViewMode ? 'Exit View Mode' : 'View Mode'}
                        </button>

                        <Link to={`/nursery/store/view/${nurseryId}?activeTab=${tabName.split(" ").join("").toLowerCase()}`} className="btn btn-sm btn-outline-info workflow-btn"><span style={{ fontSize: "16px" }} className="material-symbols-outlined me-1">open_in_new</span> Public Store</Link>

                        {
                            status.toLocaleLowerCase() === 'draft' ?
                                <button className="btn btn-sm btn-success workflow-btn" onClick={() => dispatch(nurseryStoreTabEditAsync({ id: isCurrentTab, data: { status: "publish" } }))} ><span style={{ fontSize: "16px" }} className="material-symbols-outlined me-1">public</span> Publish</button>
                                :
                                status.toLocaleLowerCase() === 'publish' &&
                                <button className="btn btn-sm btn-outline-primary workflow-btn" onClick={() => dispatch(nurseryStoreTabEditAsync({ id: isCurrentTab, data: { status: "draft" } }))} ><span style={{ fontSize: "16px" }} className="material-symbols-outlined me-1">edit</span> Switch to Draft</button>
                        }

                        <button className="btn btn-sm btn-outline-danger workflow-btn" onClick={() => dispatch(nurseryStoreTabDeleteAsync(isCurrentTab))}><span style={{ fontSize: "16px" }} className="material-symbols-outlined me-1">delete</span> Delete Tab</button>
                    </div>
                </div>


                {
                    content && content.length === 0 ?
                        <div className="p-4 p-md-5">
                            <div className='nursery-store-placeholder' onClick={() => { setIsChooseModeOpen(true); setAtIndex(0) }}>
                                <i className="fas fa-plus-circle"></i>
                                <h4>Add Your First Content Block</h4>
                            </div>
                        </div>
                        :
                        <div className='template-in-use-container'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className="border w-100"></div>
                                <div className="rounded p-2 cursor-pointer" style={{ fontSize: "20px" }} onClick={() => { setAtIndex(0); setIsChooseModeOpen(true) }}><i className="fas fa-plus-circle"></i></div>
                                <div className="border w-100"></div>
                            </div>
                            {renderContents}
                        </div>
                }
            </div>
            {
                isChooseModeOpen && <ChooseTemplate setIsChooseModeOpen={setIsChooseModeOpen} handelSelectedTemplate={handelSelectedTemplate} />
            }

            {
                isModelOpen &&
                <AddBlocksModel isModelOpen={isModelOpen} setIsModelOpen={setIsModelOpen} setAtBlockIndex={setAtBlockIndex} atBlockIndex={atBlockIndex} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={isCurrentTemplates} isCurrentTab={isCurrentTab} />
            }


            {
                isModelOpenEdit &&
                <EditBlocksModel isModelOpenEdit={isModelOpenEdit} setIsModelOpenEdit={setIsModelOpenEdit} setIsCurrentBlock={setIsCurrentBlock} isCurrentBlock={isCurrentBlock} setIsCurrentTemplates={setIsCurrentTemplates} isCurrentTemplates={isCurrentTemplates} isCurrentTab={isCurrentTab} />
            }
        </>
    );
}

export default TabsViewEditing